// extracted by mini-css-extract-plugin
export default {"good":"index_good_HfqXX","change":"index_change_lqfsF","good1":"index_good1_YI-pU","change1":"index_change1_gcVlV","good2":"index_good2_VdiM4","change2":"index_change2_kc-XY"};